import { useSankeyFormContext } from 'contexts/sankeyFormContext';
import Button from 'ui/Button';
import EmptyState from 'ui/EmptyState';
import Icon from 'ui/Icon';
import { Box, VStack } from 'ui/Layout';
import Menu from 'ui/Menu';
import Skeleton from 'ui/Skeleton';

import Page from '../components/Page';
import { ReadOnlySankeyChart } from '../components/SankeyChart';
import {
  pathToSankey,
  useCurrentRouteSankeyId,
  websiteLinkTo,
} from '../utils/routes';

const SankeyIFramedPage: React.FC = () => {
  const currentSankeyId = useCurrentRouteSankeyId();
  const { isErrorFetching, isLoading } = useSankeyFormContext();

  return (
    <Page>
      {isLoading ? (
        <Skeleton.Row w="100%" h="100%" />
      ) : isErrorFetching ? (
        <EmptyState flexGrow={1} icon="bug" title="Diagram not found" />
      ) : (
        <VStack
          alignItems="stretch"
          justifyContent="center"
          overflowX="hidden"
          w="100vw"
          h="100vh"
        >
          <Box position="relative">
            <ReadOnlySankeyChart hasBorder={false} />
            <Menu.Root>
              <Menu.Trigger>
                <Button
                  background="transparent !important"
                  variant="neutral-ghost"
                  position="absolute"
                  size="sm"
                  right={2}
                  bottom={2}
                >
                  <Icon icon="bars" transform="scale(1.6)" />
                </Button>
              </Menu.Trigger>
              <Menu.Content>
                <Menu.Item
                  value="view-image-source"
                  onClick={() => {
                    window.open(
                      websiteLinkTo(pathToSankey(currentSankeyId)),
                      '_blank'
                    );
                  }}
                >
                  View image source
                </Menu.Item>
              </Menu.Content>
            </Menu.Root>
          </Box>
        </VStack>
      )}
    </Page>
  );
};

export default SankeyIFramedPage;
